// 消息列表
<template>
  <div class="sld_msg_list">
    <div class="nav_bar_container flex_column_start_start">
      <div class="msg_title">消息中心</div>
      <div class="nav_bar flex_row_start_center">
        <div
          v-for="(navItem, index) in navList"
          :key="index"
          class="nav_item cursor_pointer"
          :class="{ active: curTplTypeCode === navItem.code }"
          @click="changeNav(navItem.code)"
        >
          {{ navItem.label }}
          <span  class="unread-count"  v-if="unreadCounts[navItem.code] > 0">
            <span>(</span>{{ unreadCounts[navItem.code] >= 99 ? '99+' : unreadCounts[navItem.code] }}<span>)</span>
          </span>
        </div>
      </div>
    </div>
    



    <!-- <div class="msg_title">{{ listTitle }}</div> -->
    <div class="msg_con" v-if="(noticeList.data && noticeList.data.length > 0) || kefuList">
      <!-- <div class="msg_con_top flex_row_start_center">
        <el-checkbox v-model="checkedAll" @change="checkMsgAll">{{
          L['全选']
        }}</el-checkbox>
        <div class="msg_con_right flex_row_start_center">
          <div class="msg_del flex_row_center_center cursor_pointer" @click="delMsg()">
            <img src="@/assets/msg/msg_del.png" alt="" />
            <span>{{ L['删除'] }}</span>
          </div>
          <div class="msg_read flex_row_center_center cursor_pointer" @click="readMsg">
            <img src="@/assets/msg/msg_read.png" alt="" />
            <span>{{ L['批量标为已读'] }}</span>
          </div>
          <div class="msg_read msg_allClose flex_row_center_center cursor_pointer" @click="allMsg">
            <img src="@/assets/msg/msg_allClose.png" alt="" />
            <span>{{ L['全部标为已读'] }}</span>
          </div>
        </div>
      </div> -->
      <div class="msg_list">
        <!-- 客服 -->
        <!-- <div class="msg_list_pre" v-for="(kefuItem, kefuIndex) in kefuList" :key="kefuIndex">
          <div v-if="kefuItem.tplCode == 'cs_msg'" class="msg_title_container flex_row_between_center" >
               <div class="flex_row_start_center" style="margin-bottom: 10px;">
                <img style="width: 26px;height: 26px;border-radius: 50%;margin-right: 15px;" src="../../assets/kefu_logo.png" alt="">
                <p class="msg_pre_title_top" style="margin-bottom: 0px;" :class="{inactive: kefuItem.isFinish == 1}">{{ kefuItem.msgTitle }}</p>
               </div>
              <div class="flex_row_end_center">
                <p class="msg_pre_time"  :class="{inactive: kefuItem.isFinish == 1}">{{ kefuItem.msgSendTime }}</p>
                <div v-if="kefuItem.msgState == 0" class="red_icon"></div>
              </div>
            </div>
            <div class="msg_pre">
              <div class="msg_content flex_column_between_start">
              <div class="msg_content_left flex_row_start_center">
               <div>
                <p :class="{inactive: kefuItem.isFinish == 1}" class="msg_content_title">
                    {{ kefuItem.msgContent }}
                  </p> 
               </div> 
              </div>
              <div v-if="kefuItem.isFinish == 0" class="msg_content_right cursor_pointer" @click="goMsgDetail(kefuItem)">
                {{ L['立即查看'] }}
              </div>
              <div v-else :class="{inactive: kefuItem.isFinish == 1}" class="msg_content_right cursor_pointer" >
                {{ L['已结束'] }}
              </div>
            </div>

            </div>
        </div> -->
        <div class="msg_list_pre" v-if="kefuList && curTplTypeCode == 'member_notice'">
          <div  class="msg_title_container flex_row_between_center" >
               <div class="flex_row_start_center" style="margin-bottom: 10px;">
                <img style="width: 26px;height: 26px;border-radius: 50%;margin-right: 15px;" src="../../assets/kefu_logo.png" alt="">
                <p class="msg_pre_title_top" style="margin-bottom: 0px;">{{ kefuList.msgTitle }}</p>
               </div>
              <div class="flex_row_end_center">
                <p class="msg_pre_time" >{{ formatSmartTime(kefuList.msgSendTime) }}</p>
                <div v-if="kefuList.msgState == 0" class="red_icon"></div>
              </div>
            </div>
            <div class="msg_pre">
              <div class="msg_content flex_column_between_start">
              <div class="msg_content_left flex_row_start_center">
               <div>
                <p  class="msg_content_title">
                    {{ kefuList.msgContent }}
                  </p> 
               </div> 
              </div>
              <div  class="msg_content_right cursor_pointer" @click="goMsgDetail(kefuList)">
                {{ L['立即查看'] }}
              </div>
              <!-- <div  class="msg_content_right cursor_pointer" >
                {{ L['已结束'] }}
              </div> -->
            </div>

            </div>
        </div>
        <!-- 非客服 -->
        <div class="msg_list_pre" v-for="(noticeItem, noticeIndex) in noticeList.data" :key="noticeIndex">
          <div>
            
            <div class="msg_title_container flex_row_between_center" >
              <p class="msg_pre_title_top" :class="{inactive: noticeItem.isFinish == 1}">{{ noticeItem.msgTitle }}</p>
              <p class="msg_pre_time"  :class="{inactive: noticeItem.isFinish == 1}">{{ formatSmartTime(noticeItem.msgSendTime) }}</p>
            </div>
          </div>
          
          
          <div class="msg_pre">
            <!-- <div class="msg_pre_title flex_row_between_center">
              <el-checkbox v-model="noticeItem.checked" class="pre_title_left" @change="noticeChecked()">{{
                noticeItem.tplName }}</el-checkbox>
              <el-popconfirm :confirmButtonText="L['确定']" :cancelButtonText="L['取消']" icon="el-icon-info" iconColor="red"
                :title="L['确定删除这条消息吗？']" @confirm="delMsg(noticeItem.receiveId)">
                <template #reference><i class="iconfont iconziyuan51 pre_title_right cursor_pointer"></i></template>
              </el-popconfirm>
            </div> -->
            <!-- 	消息状态：0--未读，1--已读，2--删除 -->
            <div class="msg_content flex_column_between_start">
              <div class="msg_content_left flex_row_start_center">
                <!-- v-if="noticeItem.msgImg" -->
               <img v-if="noticeItem.msgImg" :src="noticeItem.msgImg" alt="">
               <img v-if="noticeItem.tplCode == 'member_day'" src="../../assets/member_day.png" alt="">
               <img v-if="noticeItem.tplCode == 'member_birthday'" src="../../assets/member_birthday.png" alt="">
               <div>
                <div v-if="noticeItem.tplCode == 'member_day'" class="flex_column_start_start msg_content_title_spe">
                  <div>会员狂欢日</div>
                  <div>每月21号宠粉送福利</div>
                  <div>9积分抽正价商品！点击抽奖></div>
                </div>
                <!-- <div v-if="noticeItem.tplCode == 'member_birthday'" class="flex_column_start_start msg_content_title_spe">
                  <div>会员狂欢日</div>
                  <div>每月21号宠粉送福利</div>
                  <div>9积分抽正价商品！点击抽奖></div>
                </div> -->
               
                <p v-else :class="{inactive: noticeItem.isFinish == 1}" class="msg_content_title">
                    {{ noticeItem.msgContent }}
                  </p> 
               </div> 
              
                <!-- <span class="msg_tips" v-if="noticeItem.msgState == 0"></span>
                <p :class="{ active: noticeItem.msgState == 1 }">
                  {{ noticeItem.msgContent }}
                </p> -->
              </div>
              <div v-if="noticeItem.isFinish == 0" class="msg_content_right cursor_pointer" @click="goMsgDetail(noticeItem)">
                {{ L['立即查看'] }}
              </div>
              <div v-else :class="{inactive: noticeItem.isFinish == 1}" class="msg_content_right cursor_pointer" >
                {{ L['已结束'] }}
              </div>
            </div>
          </div>
        </div>
        
      </div>

      <div class="flex_row_center_center sld_pagination sld_page_bottom" v-if="noticeData.data &&
          noticeData.data.pagination &&
          noticeData.data.pagination.total
          ">
          <el-pagination @current-change="handleCurrentChange" v-model:currentPage="current" :page-size="pageSize"
            layout="prev, pager, next" :total="noticeData.data.pagination.total" :hide-on-single-page="true">
          </el-pagination>
        </div>
    </div>
    <!-- <div class="empty" v-if="!noticeList.data || (noticeList.data && noticeList.data.length == 0)">
        <img src="@/assets/acode_empty.png" alt="">
        <div>暂无相关消息</div>
      </div> -->
    <!-- <SldCommonEmpty v-if="!noticeList.data || (noticeList.data && noticeList.data.length == 0)
      " totalWidth="900" totalHeight="300" style="color:#666" :tip="L['暂无相关消息']" /> -->
      <div class="mes_empty flex_row_center_center"  v-if="!noticeList.data || (noticeList.data && noticeList.data.length == 0)"  >
        <img src="../../assets/msg/no_message.png" alt="">
        <span>暂无相关消息</span>
      </div>
  </div>
</template>

<script>
import {
  getCurrentInstance,
  onMounted,
  reactive,
  ref,
  watchEffect,
  watch
} from 'vue'
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import SldCommonEmpty from '../../components/SldCommonEmpty'
export default {
  components: {
    SldCommonEmpty
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const route = useRoute()
    const router = useRouter()
    const L = proxy.$getCurLanguage()
    const current = ref(1)
    const pageSize = ref(5)
    const total = ref(0)
    // const promotionNum = ref(0)
    // const businessNum = ref(0)
    // const noticeNum = ref(0)
    // const commentNum = ref(0)
    const noticeList = reactive({ data: [] }) //消息列表
    const kefuList = ref('')
    const kefuListAll = reactive({ data: {} })
    const checkedAll = ref(false) //全选是否选中
    const noticeData = reactive({ data: {} }) //消息数据
    const receiveIds = ref('') //被选中的id集
    // const curTplTypeCode = ref('member_promotion') 
    // 未读消息数量
    const unreadCounts = ref({
      member_promotion: 0,
      member_business: 0,
      member_notice: 0,
      member_comment: 0,
    });
     // 导航栏数据
     const navList = ref([
      { code: 'member_promotion', label: L['优惠促销'] },
      { code: 'member_business', label: L['交易物流'] },
      { code: 'member_notice', label: L['服务通知'] },
      { code: 'member_comment', label: L['评价消息'] },
    ]);

    // 当前选中的导航项
    const curTplTypeCode = ref(navList.value[0].code);//消息nav当前的项的tplTypeCode,默认为member_promotion，消息列表全部
    const listTitle = ref(navList.value[0].label);

    onMounted(() => {
      getMsglist(curTplTypeCode.value)
      noReadMegNum()
    })
    
    // 切换导航
    const changeNav = (code) => {
      curTplTypeCode.value = code;
      listTitle.value = navList.value.find(item => item.code === code).label;
      current.value = 1; // 重置页码
      if(curTplTypeCode.value == 'member_notice'){
        getMsglist(curTplTypeCode.value);
        getMsglist('member_customer');
      }else{
        getMsglist(curTplTypeCode.value);
      }
     
      // noReadMegNum(code)
      markAsRead(code); // 标记为已读
    };

    //获取消息列表
    const getMsglist = (tplTypeCode) => {
      let params = {}
        params = {
          pageSize: pageSize.value,
          current: current.value,
          tplTypeCode: tplTypeCode
        }
        console.log('------------------------>',params.tplTypeCode)
      let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
      proxy.$post('v3/msg/front/msg/msgList', params,config).then(res => {
        if (res.state == 200) {
          if (tplTypeCode == 'member_customer') {
            kefuList.value = res.data.list[0]
            kefuListAll.data = res.data.list
            console.log('kefuListAll',kefuListAll.data)
            console.log('kefuList',kefuList.value)
          }else{
            let result = res.data
          noticeData.data = result
          console.log('noticeData.data',noticeData.data)
          noticeList.data = result.list
          console.log('noticeList.data',noticeList.data)

          // kefuList = noticeList.data.filter(notice => notice.tplTypeCode === 'member_customer');
          // console.log('noticeList.data',kefuList)
          noticeList.data.map(noticeItem => {
            noticeItem.checked = false
          })
          }
         
        } else {
          ElMessage.error(res.msg)
        }
      })
    }
    //监听
    watchEffect(() => {
      if (route.query.curTplTypeCode) {
        curTplTypeCode.value = route.query.curTplTypeCode
        // checkedAll.value = false; //是否全选置为默认值
        // getMsglist();
      }
    })

    // watch(
    //   () => curTplTypeCode.value,
    //   (nv, ov) => {
    //     if (nv != ov) {
    //       listTitle.value = listTitleMap.value.get(nv)
    //       checkedAll.value = false
    //       getMsglist()
    //     }
    //   }
    // )

    const checkMsgAll = () => {
      //全选状态是否选中
      if (checkedAll.value == true) {
        noticeList.data.map(noticeItem => {
          noticeItem.checked = true
        })
      } else {
        noticeList.data.map(noticeItem => {
          noticeItem.checked = false
        })
      }
    }

    //消息状态处理
    const noticeChecked = () => {
      let noCheckList = []
      noCheckList = noticeList.data.filter(
        noticeItem => noticeItem.checked == false
      )

      if (noCheckList.length > 0) {
        checkedAll.value = false
      } else {
        checkedAll.value = true
      }
    }
    //上一页
    const handlePrevCilickChange = () => {
      checkedAll.value = false
      current.value--
      getMsglist(curTplTypeCode.value)
    }
    //下一页
    const handleNextCilickChange = () => {
      checkedAll.value = false
      current.value++
      getMsglist(curTplTypeCode.value)
    }
    //当前页
    const handleCurrentChange = () => {
      checkedAll.value = false
      getMsglist(curTplTypeCode.value)
    }
    //选中的id集
    const checkReceiveID = () => {
      let checkList = []
      checkList = noticeList.data.filter(
        noticeItem => noticeItem.checked == true
      )
      let receiveIdsData = []
      checkList.map(checkItem => {
        receiveIdsData.push(checkItem.receiveId)
      })
      receiveIds.value = receiveIdsData.join(',')
    }
    //删除消息
    const delMsg = receiveId => {
      let params = {}
      if (receiveId) {
        params = {
          receiveIds: receiveId
        }
        delMsgMe(params)
        return
      }
      checkReceiveID()
      if (receiveIds.value) {
        params = {
          receiveIds: receiveIds.value
        }
        proxy
          .$confirm(L['确定删除这些消息吗'], L['提示'], {
            confirmButtonText: L['确定'],
            cancelButtonText: L['取消'],
            type: 'warning'
          })
          .then(() => {
            delMsgMe(params)
          })
      } else {
        ElMessage.error(L['请先选择要操作的消息！'])
      }
    }

    const delMsgMe = params => {
      proxy.$post('v3/msg/front/msg/del', params).then(res => {
        if (res.state == 200) {
          ElMessage.success(res.msg)
          getMsglist()
          proxy.$getUserInfo()
          checkedAll.value = false
        } else {
          ElMessage.error(res.msg)
        }
      })
    }

    //标为已读
    const readMsg = () => {
      checkReceiveID()
      let params = {
        receiveIds: receiveIds.value,
        tplTypeCode:'',
        allRead:'',
        receiveIdList:[]
      }
      let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
      if (receiveIds.value) {
        proxy.$post('v3/msg/front/msg/read', params,config).then(res => {
          if (res.state == 200) {
            ElMessage.success(res.msg)
            checkedAll.value = false
            getMsglist()
            proxy.$getUserInfo()
          } else {
            ElMessage.error(res.msg)
          }
        })
      } else {
        ElMessage.error(L['请先选择要操作的消息！'])
      }
    }
    //全部标为已读
    const allMsg = () => {
      let params = {
        isAllRead: true,
        isPc: true,
      }
      proxy.$post('v3/msg/front/msg/read', params).then(res => {
        if (res.state == 200) {
          ElMessage.success(res.msg)
          checkedAll.value = false
          getMsglist()
          proxy.$getUserInfo()
        } else {
          ElMessage.error(res.msg)
        }
      })
    }

    const readMsgNOTip = () => {
      checkReceiveID()
      let params = {
        // receiveIds: receiveIds.value,
        tplTypeCode:'',
        allRead:0,
        receiveIdList:[receiveIds.value]
      }
      let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
      if (receiveIds.value) {
        proxy.$post('v3/msg/front/msg/read', params,config).then(res => {
          if (res.state == 200) {
            // getMsglist(curTplTypeCode.value)
            proxy.$getUserInfo()
          }
        })
      }
    }

    const noReadMegNum = () => {
      let params = {
      }
        proxy.$post('v3/msg/front/msg/msgListNum', params).then(res => {
          if (res.state == 200) {
            let msgTypeList = res.data
            console.log('msgTypeList',msgTypeList)
            msgTypeList.forEach(item => {
            if (unreadCounts.value[item.tplTypeCode] !== undefined) {
              unreadCounts.value[item.tplTypeCode] = item.msgNum;
            }
          });
          }
          else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          console.error('获取未读消息数量失败:', error);
          //异常处理
        })
    }

  //   "allRead": 0,
	// "receiveIdList": [],
	// "tplTypeCode": ""
      // 标记消息为已读
      const markAsRead = async (code) => {
        let params = {
          tplTypeCode:code,
          receiveIdList:[],
          allRead:0
        }
        let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try {
              const res = await proxy.$post('v3/msg/front/msg/read', params,config);
              if (res.state === 200) {
                // ElMessage.success('标记为已读成功');
                noReadMegNum(); // 重新获取未读消息数量
              } else {
                ElMessage.error(res.msg);
              }
            } catch (error) {
              console.error('标记为已读失败:', error);
              ElMessage.error('标记为已读失败，请稍后重试');
            }
          };


    // //消息跳转
    // const goMsgDetail = noticeItem => {
    //   let msgLinkInfo = JSON.parse(noticeItem.msgLinkInfo)
    //   let curNotice = [] //当前消息
    //   curNotice = noticeList.data.filter(
    //     item => item.receiveId == noticeItem.receiveId
    //   )
    //   if (curNotice && curNotice.length > 0) {
    //     curNotice[0].checked = true
    //     readMsgNOTip()
    //   }
    //   let newWin = null
    //   switch (msgLinkInfo.url_type) {
    //     //仅退款
    //     case 'order_news':
    //       if (
    //         msgLinkInfo.orderType &&
    //         msgLinkInfo.orderType == 'integral_order'
    //       ) {
    //         newWin = router.resolve({
    //           path: '/member/pointOrder/detail',
    //           query: {
    //             orderSn: msgLinkInfo.orderSn
    //           }
    //         })
    //       } else {
    //         newWin = router.resolve({
    //           path: '/member/order/detail',
    //           query: {
    //             orderSn: msgLinkInfo.orderSn
    //           }
    //         })
    //       }
    //       break

    //     case 'balance_change':
    //       newWin = router.resolve({
    //         path: '/member/balance'
    //       })
    //       break

    //     case 'coupon':
    //       newWin = router.resolve({
    //         path: '/member/coupon'
    //       })
    //       break
    //     //退款退货
    //     case 'return_news':
    //       newWin = router.resolve({
    //         path: '/member/order/refund/detail',
    //         query: {
    //           afsSn: msgLinkInfo.afsSn,
    //           curTitleId: 2
    //         }
    //       })
    //       break

    //     case 'integral_change':
    //       newWin = router.resolve({
    //         path: '/member/myPoint'
    //       })
    //       break

    //     case 'appointment_news':
    //       newWin = router.resolve({
    //         path: '/goods/detail',
    //         query: {
    //           productId: msgLinkInfo.productId
    //         }
    //       })
    //       break

    //     case 'refund_news':
    //       newWin = router.resolve({
    //         path: '/member/order/refund/detail',
    //         query: {
    //           afsSn: msgLinkInfo.afsSn,
    //           curTitleId: 1
    //         }
    //       })
    //       break
    //   }
    //   window.open(newWin.href, '_blank')
      
    // }

    const goMsgDetail = noticeItem => {
      let msgLinkInfoJson = {};
      try {
        msgLinkInfoJson = noticeItem.msgLinkInfoJson;
      } catch (error) {
        console.error('Failed to parse msgLinkInfo:', noticeItem.msgLinkInfoJson);
        return;
      }

      // 标记当前消息为已读
      let curNotice = noticeList.data.filter(
        item => item.receiveId == noticeItem.receiveId
      );
      if (curNotice && curNotice.length > 0) {
        curNotice[0].checked = true;
        readMsgNOTip();
      }

      if(noticeItem.tplCode == 'cs_msg'){
        // 将客服消息列表中的所有消息标记为已读
        kefuListAll.data.forEach(item => {
          item.checked = true;
        })
        readMsgNOTip();
      }
      //  // 客服--标记当前消息为已读
      //  let curNoticeKefu = kefuListAll.data.filter(
      //   item => item.receiveId == noticeItem.receiveId
      // );
      // if (curNoticeKefu && curNoticeKefu.length > 0) {
      //   curNoticeKefu[0].checked = true;
      //   readMsgNOTip();
      // }

      let msgLinkInfo = {
        info: {
          decoId: msgLinkInfoJson.info?.decoId ?? null, // 从 msgLinkInfoJson 中提取 decoId
          defaultProductId: msgLinkInfoJson.info?.defaultProductId ?? null // 从 msgLinkInfoJson 中提取 defaultProductId
        },
        url: msgLinkInfoJson.url,
        url_type: msgLinkInfoJson.url_type
      };

      console.log('msgLinkInfo:', msgLinkInfo);
      // 根据 url_type 解析跳转路径
      let newWin = null;
      switch (msgLinkInfo.url_type) {
        // 商品
        case 'goods':
          if (!msgLinkInfo.info.defaultProductId) {
            console.error('defaultProductId is goods for goods type');
            return;
          }
          newWin = router.resolve({
            path: '/goods/detail',
            query: {
              productId: msgLinkInfo.info.defaultProductId
            }
          });
          break;
        // 订单 
        case 'order':
          if (!msgLinkInfo.url) {
            console.error('url is missing for order type');
            return;
          }
          newWin = router.resolve({
            path: '/member/order/detail',
            query: {
              orderSn: msgLinkInfo.url
            }
          });
          break;
            // 售后订单
        case 'afterSale':
          if (!msgLinkInfo.url) {
            console.error('url is missing for afterSale type');
            return;
          }
          newWin = router.resolve({
            path: '/member/order/refund/detail',
            query: {
              afsSn: msgLinkInfo.url,
              curTitleId: 1
            }
          });
          break;
          // 标签
          case 'tag':
          if (!msgLinkInfo.url) {
            console.error('url is missing for tag type');
            return;
          }
          newWin = router.resolve({
            path: '/goods/list',
            query: {
              tagId: msgLinkInfo.url,
              curTitleId: 1
            }
          });
          break;
          // 分类
          case 'category':
          if (!msgLinkInfo.url) {
            console.error('url is missing for category type');
            return;
          }
          newWin = router.resolve({
            path: '/goods/list',
            query: {
              categoryId: msgLinkInfo.url,
              curTitleId: 1
            }
          });
          break;
          // 专题页
          case 'topic':
          if (!msgLinkInfo.info.decoId) {
            console.error('decoId is missing for topic type');
            return;
          }
          newWin = router.resolve({
            path: '/topic',
            query: {
              id: msgLinkInfo.info.decoId,
              curTitleId: 1
            }
          });
          break;
          // 关键字
          case 'keyword':
          if (!msgLinkInfo.url) {
            console.error('url is missing for keyword type');
            return;
          }
          newWin = router.resolve({
            path: '/goods/list',
            query: {
              keyword: msgLinkInfo.url,
              curTitleId: 1
            }
          });
          break;

          // 优惠券对应列表
          case 'coupon':
          if (!msgLinkInfo.url) {
            console.error('url is missing for coupon type');
            return;
          }
          newWin = router.resolve({
            path: '/member/coupon',
            query: {
              couponId: msgLinkInfo.url,
              curTitleId: 1
            }
          });
          break;

          // 咨询客服
          case 'cs':
          gotokefu({productId:0});
          break;
          // 我的积分
          case 'myIntegral':
          // if (!msgLinkInfo.url) {
          //   console.error('url is missing for myIntegral type');
          //   return;
          // }
          newWin = router.resolve({
            path: '/member/myPoint',
            query: {
              // afsSn: msgLinkInfo.url,
              // curTitleId: 1
            }
          });
          break;
          // 积分商城
          case 'integralStore':
          if (!msgLinkInfo.url) {
            console.error('url is missing for integralStore type');
            return;
          }
          newWin = router.resolve({
            path: '',
            query: {
              // afsSn: msgLinkInfo.url,
              // curTitleId: 1
            }
          });
          break;

          // 会员中心
          case 'memberCenter':
          if (!msgLinkInfo.url) {
            console.error('url is missing for memberCenter type');
            return;
          }
          newWin = router.resolve({
            path: '/point/pointIndex/Index',
            query: {
              // afsSn: msgLinkInfo.url,
              // curTitleId: 1
            }
          });
          break;
          // 会员日活动落地页
          case 'memberDay':
          if (!msgLinkInfo.url) {
            console.error('url is missing for memberDay type');
            return;
          }
          newWin = router.resolve({
            path: '',
            query: {
              // afsSn: msgLinkInfo.url,
              // curTitleId: 1
            }
          });
          break;
          // 生日领券页
          case 'birthday':
          if (!msgLinkInfo.url) {
            console.error('url is missing for birthday type');
            return;
          }
          newWin = router.resolve({
            path: '',
            query: {
              // afsSn: msgLinkInfo.url,
              // curTitleId: 1
            }
          });
          break;
        // 订单评价
          case 'goodsEva':
          if (!msgLinkInfo.info.defaultProductId) {
            console.error('url is missing for goodsEva type');
            return;
          }
          newWin = router.resolve({
            path: '/member/order/evaluate',
            query: {
              productId: msgLinkInfo.info.defaultProductId,
              curTitleId: 1
            }
          });
          break;

        default:
          console.error('Unknown url_type:', msgLinkInfo.url_type);
          return;
      }

      // 检查 newWin 是否有效
      if (!newWin || !newWin.href) {
        console.error('Failed to resolve route for url_type:', msgLinkInfo.url_type);
        return;
      }

      // 打开新页面
      window.open(newWin.href, '_blank');
    };


    //跳转
    const diyNavTo = (val) => {
      proxy.$diyNavTo(val)
    }
    const gotokefu = (e) => {
      // const platform = 'ecstore';
      // const type = '1';
      // const isTourist = 0;
      // if (store.state.loginFlag) {
      //   var leftPosition = window.screen.width - 1200;
      //   let url = "https://dev-asus.njsyue.com/cs/web/app/index.html#/home-page?userId=" 
      //     + memberInfo.value.memberId + "&platform=" + platform + "&type=" + type 
      //     + "&isTourist=" + isTourist + "&from=pc";
      //   var windowFeatures = `width=1100,height=700,left=${leftPosition},top=100,scrollbars=no`; 
      //   window.open(url, '_blank',windowFeatures)
      // } else {
      //   router.push({  path: '/login',query:{} })
			// }
      proxy.$gotokefu(e);
    };


    // 时间格式化函数
    const formatSmartTime = (dateTimeStr) => {
      const inputDate = new Date(dateTimeStr);
      const now = new Date();
      
      // 今天 00:00:00
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      // 昨天 00:00:00
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      // 7天前 00:00:00
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

      // 格式化时间部分（HH:mm）
      const formatTime = (date) => {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      };

      // 格式化完整日期+时间（YYYY-MM-DD HH:mm）
      const formatFullDateTime = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${formatTime(date)}`;
      };

      // 星期几
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      
      if (inputDate >= today) {
        return formatTime(inputDate); // 今天 → "10:30"
      } else if (inputDate >= yesterday) {
        return `昨天 ${formatTime(inputDate)}`; // 昨天 → "昨天 14:20"
      } else if (inputDate >= sevenDaysAgo) {
        return weekDays[inputDate.getDay()]; // 7天内 → "星期一"
      } else {
        return formatFullDateTime(inputDate); // 7天外 → "2024-12-29 18:15"
      }
    };
    return {
      current,
      gotokefu,
      formatSmartTime,
      pageSize,
      noticeList,
      checkedAll,
      noticeChecked,
      noticeData,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      delMsg,
      receiveIds,
      readMsg,
      curTplTypeCode,
      L,
      goMsgDetail,
      listTitle,
      checkMsgAll,
      allMsg,
      changeNav,
      navList,
      total,
      noReadMegNum,
      readMsgNOTip,
      // promotionNum,
      // businessNum,
      // noticeNum,
      // commentNum,
      markAsRead,
      unreadCounts ,
      diyNavTo,
      checkReceiveID,
      kefuList,
      kefuListAll
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
@import '../../style/iconfont.css';
@import '../../style/msgList.scss';

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 0 200px 0;
  > img {
    width: 120px;
    height: 120px;
    -webkit-user-drag: none;
    // user-drag: none;
  }
  > div {
    margin-top: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 15px;
    color: #888e98;
    line-height: 24px;
  }
}

.mes_empty{
  background: #ffffff;
  width: 100%;
  height: 240px;
  >img{
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  >span{
    font-weight: 400;
    font-size: 15px;
    color: #000000;
    line-height: 24px;
  }
}

// .el-checkbox__input.is-checked .el-checkbox__inner,
// .el-checkbox__input.is-indeterminate .el-checkbox__inner {
//   background-color: var(--color_main);
//   border-color: var(--color_main);
// }

// .el-checkbox__inner:hover {
//   border-color: var(--color_main);
// }

// .el-checkbox__input.is-checked+.el-checkbox__label {
//   color: var(--color_main);
// }

// ::v-deep.sld_pagination{
//     .el-pagination.is-background .el-pager li:not(.disabled).active {
//       background-color: #FFFFFF!important;
//       font-weight: 400!important;
//       font-size: 13px!important;
//       color: #1E7CFF!important;
//       line-height: 28px!important;
//       text-align: center!important;
//       border: 1px solid #1E7CFF!important;
//       border-radius: 0px!important;
//   }

//   .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
//       // margin: 0 5px;
//       background-color: #FFFFFF!important;
//       border: 1px solid #EAEDF0!important;
//       font-weight: 400!important;
//       font-size: 13px!important;
//       color: #888E98!important;
//       line-height: 28px!important;
//       text-align: center!important;
//       border-radius: 0px!important;
//   }
// }
</style>
